import i18n from 'i18next';
import React from 'react';
import {FaUser} from 'react-icons/fa/';
import {notification, SwAction, SwDetail, SwForm, SwPagination, SwProgressBar} from 'simplifyworks-core-ui';
import {recreateTemporaryUser} from '../../rest/index.js';

const TemporaryUserDetail = (props) => {
	const temporaryUserId = props?.params?.id;
	const progressTitle = i18n.t('foedusMsg-recreateInProgress');
	const progressMessage = <SwProgressBar centered />;

	return (
		<SwDetail
			rest='/api/foedus/contacts/temporary-users'
			restId={props.params?.id}
			exitPath='/contacts/temporary-users'
			tabName={props?.params?.tabName}
			disabled
		>
			<SwAction
				getOptions={() => ({
					onClick: () => {
						notification.showMessage({
							level: 'info',
							title: progressTitle,
							message: progressMessage
						});

						recreateTemporaryUser(
							temporaryUserId,
							() => {
								notification.showLocalizedMessage({
									level: 'success',
									titleKey: 'foedusMsg-recreateSuccess'
								});

								notification.removeMessage({
									level: 'info',
									title: progressTitle,
									message: progressMessage
								});
							},
							(err) => {
								console.error(err);
								notification.showLocalizedMessage({
									level: 'error',
									titleKey: 'foedusMsg-recreateError'
								});

								notification.removeMessage({
									level: 'info',
									title: progressTitle,
									message: progressMessage
								});
							}
						);
					},
					labelKey: 'foedus-recreateUser',
					icon: FaUser
				})}
			/>

			<SwPagination listName='foedus-contacts-temporary-users-list' />

			<SwForm
				rest='base-info'
				labelKey='foedus-temporary-user'
				tabName='base-info'
			>
				<SwForm.Section type='panel' labelKey='foedus-temporary-user'>
					<SwForm.Section>
						<SwForm.String
							size={6}
							property='user.username'
							labelKey='foedus-temporary-user-username'
						/>

						<SwForm.Boolean
							size={6}
							property='user.active'
							labelKey='core-user-active'
							showNull={false}
						/>

						<SwForm.Boolean
							size={6}
							property='accessExpired'
							labelKey='foedus-temporary-user-access-expired'
							showNull={false}
						/>

						<SwForm.Datetime
							size={6}
							property='accessExpiration'
							labelKey='foedus-temporary-user-access-expiration'
							timeEnabled
						/>
					</SwForm.Section>
				</SwForm.Section>
			</SwForm>
		</SwDetail>
	);
};

export default {
	title: () => i18n.t('foedus-contacts-temporary-users-title-detail'),
	main: TemporaryUserDetail
};
